// Argus — Registry simplu pentru toolbar button refs (per windowKey).
// Folosit de FloatingWindow pentru a calcula translate target la minimize/restore animation.
// Conform cu Win11 genie effect.

const refs = new Map<string, HTMLElement>();

export function registerTaskbarButton(key: string, el: HTMLElement | null): void {
  if (el === null) {
    refs.delete(key);
    return;
  }
  refs.set(key, el);
}

export function getTaskbarButtonRect(key: string): DOMRect | null {
  const el = refs.get(key);
  return el ? el.getBoundingClientRect() : null;
}
